import React, {useState,useEffect} from 'react';
import '../../../App.css';
import Navbar from '../../../components/Navbar';
import Banner from '../../../components/Banner';
import Footer from '../../../components/Footer';
import StampType from './StampType';
import CategoryStamp from './CategoryStamp';
import CollectStamp from './CollectStamp';

const Index = () => {
  return (
    <div className="app-container">
      <Navbar/>     
      <Banner
        image={process.env.REACT_APP_S3+"banner_faq.png"} 
      />
      <StampType/>
      <CategoryStamp/>
      <CollectStamp/>
      <Footer/>
    </div>
  );
};

export default Index;